module.exports = __webpack_public_path__ + "static/media/microsoftActiveDirectory.3cb898ac.png";